module.exports = __webpack_public_path__ + "img/charging-session-infograph-mobile.3e7b04fc.webp";